import { PortalBlock } from './portal-block';

export enum PortalEditWidgetType {
  SIDEBAR = 'sidebar',
  TOPBAR = 'topbar',
  FOOTER = 'footer',
  CONTENT = 'content',
  LOGO = 'logo',
  MAIN = 'document',
  HERO = 'hero',
}
export type EditWidgetType = PortalEditWidgetType | PortalBlock;

export type EditActionType = 'edit' | 'delete' | 'plus' | 'note' | 'content';
